import React, {
  CSSProperties,
  FC,
} from 'react';
import {
  Column, Row,
} from './Styles';
import { locationIcon } from '../../../../assets/Svg';
import { Cab } from '../../../../lib/types';
import InterMediumText from '../../../../components/Text/InterMediumText';

const Location: FC<Props> = ({
  style,
  isEnglish,
  cab,
  enTitle,
  zhTitle,
  width,
  contentWidth,
}) => {
  return (
    <Column style={{ marginTop: '16px', ...style }}>
      {/* 横线 */}
      <div style={{ width: width || '197px', height: '1px', background: '#000000', opacity: 0.5 }}></div>
      {/* 地点图标标题 */}
      <Row style={{ marginTop: '9px' }}>
        {
          isEnglish ? (
            <InterMediumText opacity={0.5} fontSize={16}>
              {enTitle || 'Building address'}
            </InterMediumText>
          ) : (
            <span style={{ height: '18px', fontSize: '18px', lineHeight: '25px', fontFamily: 'PingFangSC-Medium, PingFang SC', fontWeight: 500, color: '#11202B', opacity: 0.4 }}>
              {zhTitle || '地点'}
            </span>
          )
        }
      </Row>
      {/* 地址名称 */}
      <InterMediumText fontSize={18} lineHeight={24} marginTop={5} width={contentWidth || '170px'} textAlign={'center'}>
        {cab.cabName}
      </InterMediumText>
      {/* 横线 */}
      <div style={{ width: width || '197px', height: '1px', background: '#000000', opacity: 0.5, marginTop: '10px' }}></div>
    </Column>
  );
};

export interface Props {
  style?: CSSProperties;
  isEnglish: boolean;
  cab: Cab;
  enTitle?: string;
  zhTitle?: string;
  width?: number | string;
  contentWidth?: number | string;
}

export default Location;
